export function formatPhone(phone: string): string {
  if (phone.length <= 6) {
    return phone.replace(/(\d{3})(\d{1,3})/, '$1 $2');
  } else if (phone.length <= 8) {
    return phone.replace(/(\d{3})(\d{3})(\d{0,2})/, '$1 $2-$3');
  }

  return phone.replace(/(\d{3})(\d{3})(\d{2})(\d{0,2})/, '$1 $2-$3-$4');
}
